import { gql } from '@apollo/client';
import { ApolloClient, InMemoryCache, ApolloLink, HttpLink, concat } from '@apollo/client';
const envGraphQLMap = {
    nonprod: 'https://uat-widget-api.consent-management-nonprod.collegeboard.org/graphql',
    prod: 'https://prod-widget-api.consent-management-prod.collegeboard.org/graphql',
};
async function fetchClient(env) {
    const { getAuthenticationToken, getAuthorizationToken } = (typeof cb === 'object' && cb?.core?.iam) || {};
    if (!getAuthenticationToken || !getAuthorizationToken) {
        throw new Error('getAuthenticationToken & getAuthorizationToken must be globally available ex: cb.core.iam.getAuthenticationToken()!');
    }
    const httpLink = new HttpLink({
        uri: envGraphQLMap[env],
    });
    const authMiddleware = new ApolloLink((operation, forward) => {
        operation.setContext(({ headers = {} }) => ({
            headers: {
                ...headers,
                authorization: '1234', // The graphql authorizer lambda fails if this is not provided, but it is not used
                'x-cb-catapult-authentication-token': getAuthenticationToken(),
                'x-cb-catapult-authorization-token': getAuthorizationToken(),
            },
        }));
        return forward(operation);
    });
    return new ApolloClient({
        link: concat(authMiddleware, httpLink),
        cache: new InMemoryCache(),
    });
}
const SUBMIT_DECISIONS = gql `
  mutation MyMutation($personId: ID!, $collectionPointType: CollectionPointType!, $purposes: PurposesInput!, $stateCd: String!) {
    submitConsents(personId: $personId, collectionPointType: $collectionPointType, purposes: $purposes, stateCd: $stateCd) {
      FailedEntry
      Entries {
        ErrorCode
        ErrorMessage
        EventId
      }
    }
  }
`;
export async function submitDecisions(env, personId, stateCd, collectionPointType, purposes) {
    console.log('submitDecisions()', {
        personId,
        collectionPointType,
        stateCd,
        purposes,
    });
    return fetchClient(env)
        .then((client) => {
        return client.mutate({
            mutation: SUBMIT_DECISIONS,
            variables: { personId, collectionPointType, purposes, stateCd },
        });
    })
        .then((result) => {
        console.log('Mutation Response data:', result.data);
        return true;
    })
        .catch((err) => {
        console.error(err);
        return false;
    });
}
